<!--功能介绍 -->
<template>
  <div class="container">
    <div v-if="!nodata">
      <h2 class="title" v-text="title"></h2>
      <div class="content" v-html="content"></div>
    </div>
    <div v-else class="nodata">
      <img width="100" src="../assets/image/nomsg.png" />
      <p>暂无相关信息</p>
    </div>
  </div>
</template>
<script>
import api from '@/script/util'
export default {
  name: 'FeatureIntro',
  data () {
    return {
      title: '',
      content: '',
      nodata: false
    }
  },
  created () {
    this.fetchContent()
  },
  methods: {
    async fetchContent () {
      let token = api.getVal('token')
      let companyCode = api.getVal('companyCode')
      let url = `${window.oldBaseUrl}/scInfomationAction!aboutDetail.action?token=${token}&companyCode=${companyCode}type=5&sectype=05`
      let data = await api.axios.post(url)
      if (data.status === 100) {
        this.title = data.data.title
        this.content = data.data.content
      } else {
        this.nodata = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .title {
    text-align:center;
    font-size:18px;
    line-height:24px;
    color:#666666
  }
  .content {
    padding-top:8px;
    word-break:break-all;
    text-align:justify;
    color: #666666;
    font-size: 16px;
    line-height:24px
  }
  .nodata {
    width:100%;
    height:100%;
    padding-top:50%;
    text-align:center;
    p {
      color: #aaa;
    }
  }
  .container {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// featureIntro.vue?3ee11680